const FALLBACK = 'サインインに失敗しました。時間をおいて再度お試しください。';

const MESSAGES: Record<string, string> = {
  NotAuthorizedException: 'ユーザー名またはパスワードが正しくありません。',
  UserNotFoundException: 'ユーザー名またはパスワードが正しくありません。',
  CodeMismatchException: '認証コードが正しくありません。',
  ExpiredCodeException: '認証コードの有効期限が切れました。再度サインインしてください。',
  LimitExceededException: '試行回数の上限に達しました。しばらく時間をおいて再度お試しください。',
  TooManyRequestsException: '試行回数の上限に達しました。しばらく時間をおいて再度お試しください。',
  TooManyFailedAttemptsException: '試行回数の上限に達しました。しばらく時間をおいて再度お試しください。',
  InvalidPasswordException: 'パスワードがポリシー要件を満たしていません。',
  InvalidParameterException: '入力値が不正です。',
  UserNotConfirmedException: 'ユーザーが未確認状態です。管理者に連絡してください。',
  PasswordResetRequiredException: 'パスワードリセットが必要です。管理者に連絡してください。',
  NetworkError: 'ネットワークエラーが発生しました。接続を確認してください。',
};

export function mapAuthError(error: unknown): string {
  if (error && typeof error === 'object' && 'name' in error) {
    const name = (error as { name?: unknown }).name;
    if (typeof name === 'string' && MESSAGES[name]) {
      return MESSAGES[name];
    }
  }
  return FALLBACK;
}
